<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import URL from '@/views/newmis36/util/url'
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  import Qs from 'qs'
  let dataType = {"1":"LP名单","2":"未完成开户","3":"提交开户提醒","4":"订阅信息","5":"客户留言"};
  let driverType = {"1":"PC","2":"M","3":"APP"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM
    },
    created(){
        this.formData.cols = [
            { title: window.$t('txmis.common.startTime'), field: 'startTime',type:5},
            { title: window.$t('txmis.common.endTime'), field: 'endTime',type:5},
            { title: window.$t('txmis.registerLog.dataType'), field: 'dataType',type:2,optionList:dataType,isNumber:true},
            { title: window.$t('txmis.common.phone'), field: 'phone'},
            { title: 'IP', field: 'ip'},
            { title: window.$t('txmis.registerLog.driverType'), field: 'driverType',type:2,optionList:driverType,isNumber:true},
            { title: window.$t('txmis.registerLog.utmSource'), field: 'utmSource'},
            { title: window.$t('txmis.registerLog.utmMedium'), field: 'utmMedium'},
            { title: window.$t('txmis.registerLog.utmCampaign'), field: 'utmCampaign'},
            { title: window.$t('txmis.registerLog.utmContent'), field: 'utmContent'},
            { title: window.$t('txmis.registerLog.utmTerm'), field: 'utmTerm'},
            {click:window.$t('txmis.bt.search'),auth:"registerLog.search"},
            {click:window.$t('txmis.bt.down'),auth:"registerLog.down"},
            {click:window.$t('txmis.bt.export'),auth:"registerLog.export"},
        ];
    },
    methods: {
        /*查询表单按钮点击事件*/
        formclick(clickName, data){
          if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
            this.queryData = data;
            this.$refs.childTable.defaultQueryData(data);
          }else if(window.$t('txmis.bt.down') == clickName){
              //隐藏关键字段
              const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
              download.exportExcel(URL.registeruserlog.down,param,window.$t('txmis.registerLog.register'));
          }else if(window.$t('txmis.bt.export') == clickName){
              const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
              download.exportExcel(URL.registeruserlog.down,param,window.$t('txmis.registerLog.register'));
          }
        },
        /*表格按钮点击事件*/
        bthClick (clickName, row) {
            if (clickName == "createAccount"){
                this.dataChanage(URL.registeruserlog.createAccount,{id:row.id},res =>{
                    if (res.code == 0){
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }
        },
        dataChanage(url,option,suc,fail){
            this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                this.$refs.childTable.defaultGetData(this.queryData);
                if(suc && (typeof suc == 'function')) suc(res);
            }).catch(res => {
                if(fail && (typeof fail == 'function')) fail(res);
            })
        }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.registeruserlog.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('txmis.common.phone'), field: 'phone'},
              { title: window.$t('txmis.registerLog.dataType'), field: 'dataType',render:(data)=>{
                  return dataType[data];
                  }},
              { title: window.$t('txmis.registerLog.driverType'), field: 'driverType',render:(data)=>{
                  return driverType[data];
                  }},
              { title: 'IP', field: 'ip'},
              { title: window.$t('txmis.registerLog.ipAddress'), field: 'ipAddress'},
              { title: window.$t('txmis.registerLog.href'), field: 'href'},
              { title: window.$t('txmis.registerLog.referrer'), field: 'referrer'},
              { title: window.$t('txmis.registerLog.utmSource'), field: 'utmSource'},
              { title: window.$t('txmis.registerLog.utmMedium'), field: 'utmMedium'},
              { title: window.$t('txmis.registerLog.utmCampaign'), field: 'utmCampaign'},
              { title: window.$t('txmis.registerLog.utmContent'), field: 'utmContent'},
              { title: window.$t('txmis.registerLog.utmTerm'), field: 'utmTerm'},
              { title: window.$t('txmis.common.email'), field: 'email'},
              { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.name'), field: 'userName'},
              { title: window.$t('txmis.registerLog.directPhone'), field: 'directPhone'},
              { title: window.$t('txmis.registerLog.phonePre'), field: 'phonePre'},
              { title: window.$t('txmis.registerLog.title'), field: 'title'},
              {field: "开户",title:window.$t('txmis.bt.operation'),size:"mini",click:"createAccount",type:"primary",icon:"el-icon-edit",auth:"registerLog.createAccount"},
              /*{ title: window.$t('txmis.registerLog.businessType'), field: 'businessType'},
              { title: window.$t('txmis.registerLog.ruleId'), field: 'ruleId'},*/
          ]
        }
      }
    }
  }
</script>
